<tr class="deltaker e2e-deltaker" (click)="endreValgt()">
  <td class="valgt" [matTooltip]="'Kan ikke fjerne stemmeberettiget deltaker'| translate" [matTooltipDisabled]="!erStemmeberettiget()">
    @if(erStemmeberettiget()) {
      <mat-checkbox [checked]="true" [disabled]="true" class="e2e-deltar" (click)="$event.stopPropagation()" />
    } @else {
      <mat-checkbox [formControl]="skjema().controls.valgt" class="e2e-deltar" (click)="$event.stopPropagation()" />
    }
  </td>
  <td>
    <avatar stil="liten" [medlem]="skjema().value.medlem!" [skjulTooltip]="true"/>
  </td>
  <td class="navn e2e-navn" data-testid="navn">{{ skjema().value.medlem!.navn }}</td>
  <td class="rolle">{{ aktiveMedlemsroller() }}</td>
  @if (skalSignereValgSynlig()) {
    <td class="skal-signere">
      <mat-slide-toggle [formControl]="skjema().controls.skalSignere" (click)="$event.stopPropagation()" class="e2e-skalsignere"/>
    </td>
  }
</tr>
<ng-content></ng-content>
